webpackJsonp([18],{

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(34)(
  /* script */
  __webpack_require__(744),
  /* template */
  __webpack_require__(802),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(720), __esModule: true };

/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(359);
__webpack_require__(722);
module.exports = __webpack_require__(31).Array.from;


/***/ }),

/***/ 721:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(71);
var createDesc = __webpack_require__(147);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(70);
var $export = __webpack_require__(55);
var toObject = __webpack_require__(146);
var call = __webpack_require__(356);
var isArrayIter = __webpack_require__(355);
var toLength = __webpack_require__(148);
var createProperty = __webpack_require__(721);
var getIterFn = __webpack_require__(358);

$export($export.S + $export.F * !__webpack_require__(357)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 744:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_cfg__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_handy__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__utils_handy__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      // Common Declarations
      handy: __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a,
      config: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a,
      lAction: '',
      sbarCol: '',
      sbarMsg: '',
      sbar: false,
      rules: __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.rules,
      // Repository Category Declarations
      reposCat: [],
      // Repository Declarations
      reposit: [],
      vendorList: [],
      frequency_list: ['One-Time', 'Monthly', 'Quarterly', 'Half-Yearly', 'Yearly', 'Not Applicable'],
      beingSaved: false,
      reposHeader: [{ text: 'Document Name', value: 'doc_name', width: '300px' }, { text: 'Download', value: '', width: '100px' }, { text: 'Upload Date', value: 'upload_dt', width: '210px' }, { text: 'Remarks', value: 'remarks', width: '600px' }],
      reposHeaderAgreement: [{ text: 'Document Name', value: 'doc_name', align: 'left', sortable: false }, { text: 'Download', value: '', align: 'left', sortable: false }, { text: 'Upload Date', value: 'upload_dt', align: 'center' }, { text: 'Vendor Name', value: 'vendor_name', sortable: false }, { text: 'Scope Of Work', value: 'scope_of_work', sortable: false }, { text: 'Contract Start Date', value: 'contract_start_dt', align: 'center', sortable: false }, { text: 'Contract End Date', value: 'contract_end_dt', align: 'center', sortable: false }, { text: 'Contract Value', value: 'contract_value', align: 'right', sortable: false }, { text: 'Payment Frequency', value: 'payment_frequency', align: 'center', sortable: false }, { text: 'Contact Number', value: 'contact_phone', sortable: false }, { text: 'eMail Ids', value: 'contact_email', sortable: false }, { text: 'Remarks', value: 'remarks', sortable: false }],
      // reposHeaderAgreement: [
      //   { text: 'Document Name', value: 'doc_name', align: 'left', width: '320px', sortable: false },
      //   { text: 'Download', value: '', width: '120px', align: 'left', sortable: false },
      //   { text: 'Upload Date', value: 'upload_dt', align: 'center', width: '120px' },
      //   { text: 'Vendor Name', value: 'vendor_name', width: '250px', sortable: false },
      //   { text: 'Scope Of Work', value: 'scope_of_work', width: '150px', sortable: false },
      //   { text: 'Contract Start Date', value: 'contract_start_dt', align: 'center', width: '150px', sortable: false },
      //   { text: 'Contract End Date', value: 'contract_end_dt', align: 'center', width: '150px', sortable: false },
      //   { text: 'Contract Value', value: 'contract_value', align: 'right', width: '120px', sortable: false },
      //   { text: 'Payment Frequency', value: 'payment_frequency', align: 'center', width: '150px', sortable: false },
      //   { text: 'Contact Number', value: 'contact_phone', width: '150px', sortable: false },
      //   { text: 'eMail Ids', value: 'contact_email', width: '150px', sortable: false },
      //   { text: 'Remarks', value: 'remarks', width: '300px', sortable: false }
      // ],
      lReposit: [],
      showRepositEdit: false,
      contractStartDt: false,
      contractEndDt: false

    };
  },
  created: function created() {
    this.lAction = 'view';
    this.loadReposCat();
    this.loadRepository();
    this.loadVendorDetails();
  },

  methods: {
    msg: function msg(m) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (type === 0) {
        this.sbarCol = 'error';
      } else if (type === 1) {
        this.sbarCol = 'success';
      } else {
        this.sbarCol = 'info';
      }
      this.sbar = true;
      this.sbarMsg = m;
    },
    loadReposCat: function loadReposCat() {
      var _this = this;

      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getRepositoryCategory/').then(function (response) {
        _this.reposCat = response.data;
      }).catch(function (err) {
        _this.msg(err, true);
      });
    },
    prepareRepository: function prepareRepository() {
      this.lReposit = {
        comm_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.COMM_ID,
        repos_cat_id: null,
        remarks: '',
        files: [],
        rep_vendor_id: null,
        scope_of_work: null,
        contract_start_dt: null,
        contract_end_dt: null,
        contract_value: null,
        payment_frequency: null
      };
      this.loadVendorDetails();
      this.lAction = 'create';
      this.showRepositEdit = true;
    },
    pickFile: function pickFile() {
      this.$refs.fileInput.click();
    },
    loadFilesFromFileBrowser: function loadFilesFromFileBrowser(curReposit) {
      var _this2 = this;

      var currentDate = new Date();
      var seconds = currentDate.getSeconds().toString();
      if (seconds.length < 2) {
        seconds = '0' + seconds;
      }
      var time = seconds + currentDate.getMilliseconds().toString();
      var files = event.target.files;
      if (!curReposit.files) {
        curReposit.files = [];
      }
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(files).forEach(function (file) {
        var fileReader = new FileReader();
        var getResult = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
          fileReader.onload = function (e) {
            curReposit.files.push({
              doc_url: e.target.result.split(',')[1],
              doc_name: file.name.split('.')[0] + '_' + time + '.' + file.name.split('.')[1],
              is_selected: true,
              is_changed: true
            });
            _this2.$forceUpdate();
          };
        });
        fileReader.readAsDataURL(file);
        return getResult.then(function (file) {
          return file;
        });
      });
    },
    saveChanges: function saveChanges(action) {
      var _this3 = this;

      if (this.$refs.lForm.validate()) {
        if (this.lReposit.files.length > 0 && this.lReposit.files.filter(function (rec) {
          return rec.is_selected;
        }).length > 0) {
          if (this.lReposit.repos_cat_id === 1 && (!this.lReposit.rep_vendor_id || !this.lReposit.contract_start_dt || !this.lReposit.contract_end_dt || !this.lReposit.contract_value || !this.lReposit.payment_frequency)) {
            this.msg('Please enter mandatory vendor related fields', 0);
          } else {
            this.axios.post(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/repository/' + action, this.lReposit).then(function (response) {
              setTimeout(function () {
                _this3.loadRepository();
              }, 500);
              _this3.msg('Saved Successfully', 1);
              _this3.beingSaved = false;
              _this3.lAction = 'view';
              _this3.showRepositEdit = false;
            }).catch(function (err) {
              _this3.msg(err, 0);
              _this3.beingSaved = false;
            });
          }
        } else {
          this.msg('Please attach file', 0);
        }
      }
    },
    loadRepository: function loadRepository() {
      var _this4 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getRepositoryByCommId/', qry).then(function (response) {
        _this4.reposit = response.data;
      }).catch(function (err) {
        _this4.msg(err, true);
      });
    },
    prepareUpdateReposit: function prepareUpdateReposit(curRepos) {
      this.lReposit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, curRepos);
      this.lReposit.old_repos_cat_id = curRepos.repos_cat_id;
      this.lReposit.contract_start_dt = curRepos.contract_start_dt ? __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDate(curRepos.contract_start_dt) : '';
      this.lReposit.contract_end_dt = curRepos.contract_start_dt ? __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDate(curRepos.contract_end_dt) : '';
      this.loadRepositAttachment(this.lReposit);
      this.loadVendorDetails();
      this.lAction = 'update';
      this.showRepositEdit = true;
    },
    loadRepositAttachment: function loadRepositAttachment(curReposit) {
      var _this5 = this;

      var path = __webpack_require__(354);
      var qry = {
        params: {
          doc_id: curReposit.doc_id
        }
      };
      curReposit.files = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getAttachmentByDocId/', qry).then(function (response) {
        response.data.forEach(function (rec) {
          curReposit.files.push({
            doc_url: rec.doc_url,
            doc_name: path.basename(rec.doc_url),
            is_selected: true,
            is_changed: false
          });
        });
        _this5.$forceUpdate();
      }).catch(function (err) {
        _this5.msg(err, true);
        curReposit.files = [];
      });
    },
    cancelChanges: function cancelChanges() {
      this.lAction = 'view';
      this.showRepositEdit = false;
    },
    deleteReposit: function deleteReposit(curReposit) {
      var _this6 = this;

      if (!confirm('Sure, you want to delete the Repository with name ' + curReposit.doc_name)) {
        return;
      }
      // up in db
      this.axios.post(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/repository/delete', curReposit).then(function (response) {
        _this6.loadReposCat();
        _this6.loadRepository();
        _this6.lAction = 'view';
        _this6.showRepositEdit = false;
        _this6.$forceUpdate();
      }).catch(function (err) {
        _this6.msg(err, 0);
        _this6.beingSaved = false;
      });
    },
    loadVendorDetails: function loadVendorDetails() {
      var _this7 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getRepositoryVendorsByCommId/', qry).then(function (response) {
        _this7.vendorList = response.data;
      }).catch(function (err) {
        _this7.msg(err, true);
      });
    },
    loadSelectedVendorDetails: function loadSelectedVendorDetails() {
      var _this8 = this;

      if (this.lReposit.rep_vendor_id) {
        var tempItem = this.vendorList.filter(function (rec) {
          return rec.vendor_id === _this8.lReposit.rep_vendor_id;
        });
        if (tempItem.length > 0) {
          this.lReposit.contact_name = tempItem[0].contact_name;
          this.lReposit.contact_phone = tempItem[0].contact_phone;
          this.lReposit.contact_email = tempItem[0].contact_email;
        }
      } else {
        this.lReposit.contact_name = null;
        this.lReposit.contact_phone = null;
        this.lReposit.contact_email = null;
      }
    }
  }
});

/***/ }),

/***/ 802:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, _vm._l((_vm.reposCat), function(cat, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "xs12": "",
        "sm12": ""
      }
    }, [_c('v-card', [_c('v-card-title', {
      staticClass: "py-2 title grey lighten-4"
    }, [_vm._v("\n              " + _vm._s(cat.repos_cat) + "\n            ")]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pa-0",
      style: (_vm.reposit.filter(function (rec) { return rec.repos_cat_id === cat.repos_cat_id; }).length > 5 ? 'overflow-y: scroll; height: 300px; padding: 1rem 1rem 1rem 0px;' : '')
    }, [_c('v-data-table', {
      attrs: {
        "headers": cat.repos_cat_id === 1 ? _vm.reposHeaderAgreement : _vm.reposHeader,
        "items": _vm.reposit.filter(function (rec) { return rec.repos_cat_id === cat.repos_cat_id; }),
        "disable-initial-sort": "",
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [(cat.repos_cat_id === 1) ? _c('tr', {
            on: {
              "click": function($event) {
                return _vm.prepareUpdateReposit(props.item)
              }
            }
          }, [_c('td', {
            staticStyle: {
              "text-align": "left",
              "font-size": "12px"
            }
          }, [_vm._v(" " + _vm._s(props.item.doc_name ? props.item.doc_name : '-') + " ")]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "left",
              "font-size": "12px"
            }
          }, [_c('a', {
            staticStyle: {
              "text-decoration": "none"
            },
            attrs: {
              "href": _vm.config.STATIC_FILES_DIR + props.item.doc_url,
              "download": ""
            }
          }, [_c('v-btn', {
            staticClass: "mr-0 grey lighten-1 grey--text text--lighten-4",
            attrs: {
              "small": "",
              "icon": "",
              "onclick": "event.stopPropagation()"
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("file_download")])], 1)], 1)]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "center",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.upload_dt ? _vm.handy.formatDate(props.item.upload_dt) : '-'))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "left",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.vendor_name ? props.item.vendor_name : '-'))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "left",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.scope_of_work ? props.item.scope_of_work : '-'))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "center",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.contract_start_dt ? _vm.handy.formatDate(props.item.contract_start_dt) : '-'))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "center",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.contract_end_dt ? _vm.handy.formatDate(props.item.contract_end_dt) : '-'))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "right",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.contract_value ? _vm.handy.formatCur(props.item.contract_value) : '-'))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "center",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.payment_frequency ? props.item.payment_frequency : '-'))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "left",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.contact_phone ? props.item.contact_phone : '-'))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "left",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.contact_email ? props.item.contact_email : '-'))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "left",
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.remarks ? props.item.remarks : '-'))])]) : _vm._e(), _vm._v(" "), (cat.repos_cat_id != 1) ? _c('tr', {
            on: {
              "click": function($event) {
                return _vm.prepareUpdateReposit(props.item)
              }
            }
          }, [_c('td', [_vm._v(" " + _vm._s(props.item.doc_name ? props.item.doc_name : '-') + " ")]), _vm._v(" "), _c('td', [_c('a', {
            staticStyle: {
              "text-decoration": "none"
            },
            attrs: {
              "href": _vm.config.STATIC_FILES_DIR + props.item.doc_url,
              "download": ""
            }
          }, [_c('v-btn', {
            staticClass: "mr-0 grey lighten-1 grey--text text--lighten-4",
            attrs: {
              "small": "",
              "icon": "",
              "onclick": "event.stopPropagation()"
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("file_download")])], 1)], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.upload_dt ? _vm.handy.formatDBDateTime(props.item.upload_dt) : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.remarks ? props.item.remarks : '-'))])]) : _vm._e()]
        }
      }], null, true)
    })], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; right:15px;' : 'bottom:15px; right:15px;')),
          attrs: {
            "dark": "",
            "fab": "",
            "fixed": "",
            "color": "accent"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.prepareRepository()
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Add Repository")])])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.showRepositEdit),
      callback: function($$v) {
        _vm.showRepositEdit = $$v
      },
      expression: "showRepositEdit"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "grey lighten-2 py-2",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.handy.startWithUpper(_vm.lAction)) + " Repository\n              "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showRepositEdit = false
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "items": _vm.reposCat,
      "label": "Repository Category",
      "item-text": "repos_cat",
      "item-value": "repos_cat_id",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lReposit.repos_cat_id),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "repos_cat_id", $$v)
      },
      expression: "lReposit.repos_cat_id"
    }
  })], 1), _vm._v(" "), (_vm.lReposit.repos_cat_id === 1) ? _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "items": _vm.vendorList,
      "label": "Vendor Name",
      "item-text": "vendor_name",
      "item-value": "vendor_id",
      "hide-details": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.loadSelectedVendorDetails()
      }
    },
    model: {
      value: (_vm.lReposit.rep_vendor_id),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "rep_vendor_id", $$v)
      },
      expression: "lReposit.rep_vendor_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lReposit.repos_cat_id === 1) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "label": "Vendor Contact Name",
      "hide-details": "",
      "disabled": ""
    },
    model: {
      value: (_vm.lReposit.contact_name),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "contact_name", $$v)
      },
      expression: "lReposit.contact_name"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lReposit.repos_cat_id === 1) ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "label": "Vendor Contact Number",
      "hide-details": "",
      "disabled": ""
    },
    model: {
      value: (_vm.lReposit.contact_phone),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "contact_phone", $$v)
      },
      expression: "lReposit.contact_phone"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lReposit.repos_cat_id === 1) ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "label": "Vendor Contact email",
      "hide-details": "",
      "disabled": ""
    },
    model: {
      value: (_vm.lReposit.contact_email),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "contact_email", $$v)
      },
      expression: "lReposit.contact_email"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lReposit.repos_cat_id === 1) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "label": "Contract Value",
      "hide-details": "",
      "type": "Number",
      "maxlength": "10"
    },
    model: {
      value: (_vm.lReposit.contract_value),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "contract_value", $$v)
      },
      expression: "lReposit.contract_value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lReposit.repos_cat_id === 1) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-dialog', {
    ref: "contractStartDt",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "return-value": _vm.lReposit.contract_start_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lReposit, "contract_start_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lReposit, "contract_start_dt", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticStyle: {
            "font-size": "14px"
          },
          attrs: {
            "slot": "activator",
            "label": "Contract Start Date",
            "append-icon": "mdi-calendar-today",
            "readonly": "",
            "clearable": "",
            "hide-details": "",
            "required": ""
          },
          slot: "activator",
          model: {
            value: (_vm.lReposit.contract_start_dt),
            callback: function($$v) {
              _vm.$set(_vm.lReposit, "contract_start_dt", $$v)
            },
            expression: "lReposit.contract_start_dt"
          }
        }, on))]
      }
    }], null, false, 1021666470),
    model: {
      value: (_vm.contractStartDt),
      callback: function($$v) {
        _vm.contractStartDt = $$v
      },
      expression: "contractStartDt"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lReposit.contract_start_dt),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "contract_start_dt", $$v)
      },
      expression: "lReposit.contract_start_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.contractStartDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.contractStartDt.save(_vm.lReposit.contract_start_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lReposit.repos_cat_id === 1) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-dialog', {
    ref: "contractEndDt",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "return-value": _vm.lReposit.contract_end_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lReposit, "contract_end_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lReposit, "contract_end_dt", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticStyle: {
            "font-size": "14px"
          },
          attrs: {
            "slot": "activator",
            "label": "Contract End Date",
            "append-icon": "mdi-calendar-today",
            "readonly": "",
            "clearable": "",
            "hide-details": "",
            "required": ""
          },
          slot: "activator",
          model: {
            value: (_vm.lReposit.contract_end_dt),
            callback: function($$v) {
              _vm.$set(_vm.lReposit, "contract_end_dt", $$v)
            },
            expression: "lReposit.contract_end_dt"
          }
        }, on))]
      }
    }], null, false, 1769829830),
    model: {
      value: (_vm.contractEndDt),
      callback: function($$v) {
        _vm.contractEndDt = $$v
      },
      expression: "contractEndDt"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lReposit.contract_end_dt),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "contract_end_dt", $$v)
      },
      expression: "lReposit.contract_end_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.contractEndDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.contractEndDt.save(_vm.lReposit.contract_end_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lReposit.repos_cat_id === 1) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "items": _vm.frequency_list,
      "label": "Payment Frequency",
      "hide-details": ""
    },
    model: {
      value: (_vm.lReposit.payment_frequency),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "payment_frequency", $$v)
      },
      expression: "lReposit.payment_frequency"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lReposit.repos_cat_id === 1) ? _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "label": "Scope of Work",
      "hide-details": "",
      "maxlength": "250"
    },
    model: {
      value: (_vm.lReposit.scope_of_work),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "scope_of_work", $$v)
      },
      expression: "lReposit.scope_of_work"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "label": "Remarks (if any)",
      "rows": "2",
      "hide-details": "",
      "maxlength": "250"
    },
    model: {
      value: (_vm.lReposit.remarks),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "remarks", $$v)
      },
      expression: "lReposit.remarks"
    }
  })], 1), _vm._v(" "), (_vm.lAction === 'create') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls, .xlsx, .csv, .eml, .pdf, .ppt, .pptx, .doc, .docx, image/png, image/gif, image/jpeg",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromFileBrowser(_vm.lReposit)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), (_vm.lReposit.files && _vm.lReposit.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('span', _vm._l((_vm.lReposit.files.filter(function (rec) { return rec.is_selected; })), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [_vm._v(_vm._s(file.doc_name))])], 1)
  }), 0) : _c('span', {
    staticClass: "caption"
  }, [_vm._v("Attachment if any (upto 20MB)")])], 1) : _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls, .xlsx, .csv, .eml, .pdf, .ppt, .pptx, .doc, .docx, image/png, image/gif, image/jpeg"
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromFileBrowser(_vm.lReposit)
      }
    }
  }), _vm._v(" "), (_vm.lReposit.files && _vm.lReposit.files.filter(function (rec) { return rec.is_selected; }).length === 0) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1) : _vm._e(), _vm._v(" "), (_vm.lReposit.files && _vm.lReposit.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('span', _vm._l((_vm.lReposit.files.filter(function (rec) { return rec.is_selected; })), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [_vm._v(_vm._s(file.doc_name))])], 1)
  }), 0) : _c('span', {
    staticClass: "caption"
  }, [_vm._v("Attachment if any (upto 20MB)")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.deleteReposit(_vm.lReposit)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent black--text",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/18.1b704709d0158e8509f9.js